import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-after-sales",
  "use": "icon-soc-l1-after-sales-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-after-sales\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M512 160l288 112v224c0 176-112 304-288 368-176-64-288-192-288-368V272L512 160zm0 112L288 352v144c0 120 72 216 224 272 152-56 224-152 224-272V352L512 272z\" />\r\n  <path d=\"M448 448h128v192H448V448zm0-96h128v64H448v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-after-sales.svg
// module id = cwm4
// module chunks = 478